export default "__VITE_PUBLIC_ASSET__576cce3f__"